import { Tooltip, Typography } from "@mui/material"
import { ChargeCategory } from "../../Objects/ChargeCategory"

export interface ChargeCategoryTextProps {
    chargeCategory?: ChargeCategory
    withTooltip?: boolean
    longText?: boolean
}

export default function ChargeCategoryText({
    chargeCategory,
    withTooltip = false,
    longText = true,
}: ChargeCategoryTextProps): JSX.Element {
    if (!chargeCategory) {
        return (
            <Typography>-</Typography>
        )
    }
    const member = chargeCategory.member ? "会員" : "非会員"
    const number = ((!chargeCategory.min_number && !chargeCategory.max_number)
        ? ""
        : ((chargeCategory.min_number === chargeCategory.max_number)
            ? `/${chargeCategory.min_number}人`
            : "/" + (chargeCategory.min_number ? `${chargeCategory.min_number}人` : "") + "～" + (chargeCategory.max_number ? `${chargeCategory.max_number}人` : "")))
    const timing = ((!chargeCategory.rvtiming_start && !chargeCategory.rvtiming_end)
        ? ""
        : "/" + (chargeCategory.rvtiming_start ? `${chargeCategory.rvtiming_start}日前` : "") + "～" + (chargeCategory.rvtiming_end ? `${chargeCategory.rvtiming_end}日前` : ""))
    const unit = (!chargeCategory.max_unit ? "" : `/最大${chargeCategory.max_unit}コマ`)

    const content = <Typography>
        <Typography component={"span"}>
            {chargeCategory.chrcate_name}
        </Typography>
        <Typography
            variant="body2"
            component={"span"}
            sx={{
                marginLeft: 1
            }}
        >
            ({longText ? `${member}${number}${timing}${unit}` : member})
        </Typography>
    </Typography>
    if (withTooltip) {
        return (
            <Tooltip
                arrow
                title={`${chargeCategory.chrcate_name} (${member}${number}${timing}${unit})`}
            >
                {content}
            </Tooltip>
        )
    }
    return content
}